const ROOMS_PATH = (calendarId: string) =>
  `/api/v2/pricemulti/rooms/id_calendar/${calendarId}/`

export default function(api: GlobalFetch) {
  return async function(calendarId: string) {
    const response = await api.fetch(ROOMS_PATH(calendarId))
    return await handleResponse(response)
  }
}

export async function handleResponse(response: Response) {
  const json = await response.json()
  return json.items
}
